(() => {
  if (customElements.get('product-recommendations')) {
    return;
  }

  const ProductsCarousel = customElements.get('products-carousel');

  // See recently-viewed-products.js: `extends undefined` throws at parse time
  // if the base component has not registered yet, so fail soft instead.
  if (!ProductsCarousel) {
    console.warn('[product-recommendations] products-carousel is not defined; skipping.');
    return;
  }

  class ProductRecommendations extends ProductsCarousel {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.initSwiper();
            }
          })
          .catch(e => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
